import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  ProjectContainer,
  ProjectHeader,
  ProjectTitle,
  ProjectCategory,
  ProjectYear,
  MainImage,
  ProjectContent,
  ProjectInfo,
  InfoSection,
  ProjectDescription,
  Navigation,
  NavButton,
  BackToGallery
} from '../styles/ArtProjectStyle';
import PageLayout from '../components/PageLayout';
import axios from 'axios';
import Footer from '../components/Footer';

function ArtProject() {
  const { id } = useParams();
  const [artProjects, setArtProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch project data if not already available
    axios.get(`http://localhost:8000/art`)
      .then(response => {
        setArtProjects(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching art projects:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <PageLayout>
        <ProjectContainer>
          <h1>Loading...</h1>
        </ProjectContainer>
      </PageLayout>
    );
  }

  const currentIndex = artProjects.findIndex(p => p._id === id);
  const prevProject = currentIndex > 0 ? artProjects[currentIndex - 1] : null;
  const nextProject = currentIndex < artProjects.length - 1 ? artProjects[currentIndex + 1] : null;

  if (!artProjects[currentIndex]) {
    return (
      <PageLayout>
        <ProjectContainer>
          <h1>Project not found</h1>
          <BackToGallery to="/art">Back to Gallery</BackToGallery>
        </ProjectContainer>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <ProjectContainer>
        <ProjectHeader>
          <ProjectTitle>{artProjects[currentIndex].title}</ProjectTitle>
          <ProjectCategory>{artProjects[currentIndex].category}</ProjectCategory>
          <ProjectYear>{artProjects[currentIndex].year}</ProjectYear>
        </ProjectHeader>

        <MainImage>
          <img src={artProjects[currentIndex].image} alt={artProjects[currentIndex].title} />
        </MainImage>

        <ProjectContent>
          <ProjectInfo>
            <InfoSection>
              <h3>Category</h3>
              <p>{artProjects[currentIndex].category}</p>
            </InfoSection>
            <InfoSection>
              <h3>Year</h3>
              <p>{artProjects[currentIndex].year}</p>
            </InfoSection>
            <InfoSection>
              <h3>Exhibition</h3>
              <p>{artProjects[currentIndex].exhibition}</p>
            </InfoSection>
            <InfoSection>
              <h3>Techniques</h3>
              <ul>
                {artProjects[currentIndex].techniques?.length > 0 && artProjects[currentIndex].techniques.map((technique, index) => (
                  <li key={index}>{technique}</li>
                ))}
              </ul>
            </InfoSection>
            <InfoSection>
              <h3>Details</h3>
              <p>{artProjects[currentIndex].details}</p>
            </InfoSection>
            <BackToGallery to="/art">Back to Gallery</BackToGallery>
          </ProjectInfo>

          <ProjectDescription>
            <p>{artProjects[currentIndex].description}</p>
          </ProjectDescription>
        </ProjectContent>

        <Navigation>
          {prevProject && (
            <NavButton to={`/art/${prevProject._id}`}>
              <span>←</span> Previous Project
            </NavButton>
          )}
          {nextProject && (
            <NavButton to={`/art/${nextProject._id}`} next>
              Next Project <span>→</span>
            </NavButton>
          )}
        </Navigation>
        <Footer />
      </ProjectContainer>
    </PageLayout>
  );
}

export default ArtProject; 